/**
 * Safe localStorage wrapper – funktioniert auch in sandboxed iframes und Private Browsing.
 * Wenn localStorage nicht verfügbar ist (SecurityError, QuotaExceeded, etc.), wird ein
 * in-memory Fallback verwendet.
 */
let memoryFallback = {};

function isStorageAvailable() {
  if (typeof window === "undefined") return false;
  try {
    const key = "__storage_test__";
    window.localStorage.setItem(key, key);
    window.localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

const storageAvailable = isStorageAvailable();

export function safeGetItem(key) {
  try {
    if (storageAvailable) return window.localStorage.getItem(key);
    return memoryFallback[key] || null;
  } catch {
    return memoryFallback[key] || null;
  }
}

export function safeSetItem(key, value) {
  try {
    if (storageAvailable) {
      window.localStorage.setItem(key, value);
    } else {
      memoryFallback[key] = value;
    }
  } catch {
    memoryFallback[key] = value;
  }
}

export function safeRemoveItem(key) {
  try {
    if (storageAvailable) window.localStorage.removeItem(key);
    delete memoryFallback[key];
  } catch {
    delete memoryFallback[key];
  }
}

/** Supabase-kompatibler Storage-Adapter (getItem, setItem, removeItem) */
export const safeStorageAdapter = {
  getItem: (key) => safeGetItem(key),
  setItem: (key, value) => safeSetItem(key, value),
  removeItem: (key) => safeRemoveItem(key),
};
